
import { Component, Vue } from 'vue-property-decorator';
import Bar from '@/components/Bar.vue';
import Top from '@/components/Top.vue';
import Bottom from '@/components/Bottom.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Api } from '../utils/request';
import date from '@/utils/date';
import MokYun from '@/components/MokYun.vue';
import Achievement from '@/components/Achievement.vue';
import { setCache } from '@/utils/cache';
// import ContentType from '@/interfaces/content-type';
Vue.use(ElementUI);
@Component({
  components: {
    MokYun,
    Bottom,
    Top,
    Bar,
    Achievement,
  },
})
export default class Mokyun extends Vue {
  public calleft = 0;
  public speed = 1;
  public timer2 = 0;
  public newTimer = 0;
  public cont1Show = true;
  public cont22Index = 0;
  public cont11Index = 0;
  public newsIndex = 0;
  public timer = 0;
  public fit = 'contain';
  // 当前索引
  public bannerIndex = 0;
  // 定时器
  public bannerTimer: any;
  // 小圆点开关
  public begin = false;
  public currentIndex = 0; //默认显示图片
  public configInfo: any = [];
  public bannerList: any = [];
  public indexNews: any = [];
  public indexNews2: any = [];
  public companyList: any = [];
  public notcieList: any = [];
  public constructList: any = [];
  public appliList: any = [];
  public downList: any = [];
  public menuList: any = [];
  public columnList: any = [];
  public selectMenu: any = [];
  public sliderMenu: any = [];
  public selectTitle = '';
  public linkList: any = [];
  async mounted() {
    await this.getBanner();
    await this.getMenu();
    await this.getConfig();
    await this.getColumn();
    // await this.getIndexNews();
    // await this.getCompanyList();
    // await this.getNotcie();
    // await this.getApplication();
    // await this.getDownList();
    // await this.getConstructList();
    // await this.getLinkList();
    this.goBanner();
    this.goNews();
    this.move();
  }
  beforeDestory() {
    this.timer2 = 0;
    this.newTimer = 0;
    this.timer = 0;
  }
  async getLinkList() {
    this.linkList = await Api.Config.getLinkList();
    this.configInfo.push(this.linkList);
  }
  async getColumn() {
    this.columnList = await setCache({
      key: 'columnList',
      fn: Api.Indexcolumn.getList,
      expire: 5,
    });
    this.columnList.map((v: any) => {
      v.list.map((v: any) => {
        v.uploadTime = date(v.uploadTime);
      });
    });
  }
  async getMenu() {
    this.menuList = await setCache({
      key: 'menuList',
      fn: Api.Menus.getTopMenu,
      expire: 5,
    });
    localStorage.setItem('menuList', JSON.stringify(this.menuList));
    // this.sliderMenu = await Api.Menus.getSliderMenu();
  }
  async getConfig() {
    this.configInfo = await setCache({
      key: 'configInfo',
      fn: Api.Config.getList,
      expire: 5,
    });
    localStorage.setItem('config', JSON.stringify(this.configInfo));
  }
  async getBanner() {
    this.bannerList = await setCache({
      key: 'bannerList',
      fn: Api.Banner.getList,
      expire: 5,
    });
  }
  async getApplication() {
    this.appliList = await Api.Menus.getSliderMenu();
  }
  async getDownList() {
    this.downList = await Api.Download.getList({
      page: 1,
      limit: 8,
      indexStatus: true,
    });
  }
  async getIndexNews() {
    this.indexNews = await Api.Article.getList({
      limit: 4,
      page: 1,
      menuId: this.columnList[0].parentId,
      indexStatus: true,
    });
    this.indexNews.map((v: any) => {
      v.uploadTime = date(v.uploadTime);
    });
  }
  async getNotcie() {
    this.notcieList = await Api.Article.getList({
      limit: 4,
      page: 1,
      menuId: this.columnList[0].parentId,
      indexStatus: true,
    });
    this.notcieList.map((v: any) => {
      v.uploadTime = date(v.uploadTime);
    });
  }
  async getConstructList() {
    this.constructList = await Api.Article.getList({
      limit: 8,
      page: 1,
      menuId: this.columnList[1].parentId,
      indexStatus: true,
    });
  }
  async getCompanyList() {
    const res = await Api.Company.getList({
      page: 1,
      limit: 5,
      indexStatus: true,
    });
    res.map((v: any) => {
      v.joinTime = date(v.joinTime);
    });
    this.companyList = res;
  }
  goInfo(id: any, type: any) {
    this.$router.push({
      name: 'Content',
      path: '/content',
      query: { id, type },
    });
    // const routeUrl = this.$router.resolve({
    //   name: 'Content',
    //   path: '/content',
    //   query: { id, type },
    // });
    // window.open(routeUrl.href, '_blank');
    scrollTo(0, 0);
  }
  switchNews(index: any) {
    this.newsIndex = index;
  }

  changeCont22Index(index: any) {
    if (index === this.cont22Index) {
      return;
    }
    this.cont22Index = index;
  }

  changeCont11Index(index: any) {
    if (index === this.cont11Index) {
      return;
    }
    this.cont11Index = index;
  }
  goMore(id: any, parentId: any, jumpType: any, title: string) {
    localStorage.setItem('page', String(1));
    this.$router.push({
      path: '/list',
      query: {
        id,
        parentId,
        type: jumpType,
        title: title,
      },
    });
    scrollTo(0, 0);
  }
  //banner 轮播图
  goBanner() {
    this.bannerTimer = setInterval(() => {
      this.autoPlay();
    }, 4000);
  }
  goNews() {
    this.newTimer = setInterval(() => {
      this.autoNews();
    }, 6000);
    this.autoNews();
  }
  stop() {
    clearInterval(this.bannerTimer);
    this.bannerTimer = null;
  }
  change(index: any) {
    this.bannerIndex = index;
  }
  autoPlay() {
    this.bannerIndex++;
    if (this.bannerIndex > this.bannerList.length - 1) {
      this.bannerIndex = 0;
    }
  }
  autoPlayCampany() {
    this.cont22Index++;
    if (this.cont22Index > this.columnList[2].list.length - 1) {
      this.cont22Index = 0;
    }
  }
  autoNews() {
    this.newsIndex++;
    if (this.newsIndex > this.indexNews.length - 1) {
      this.newsIndex = 0;
    }
  }
  carouseTransition() {
    this.begin = false;
  }
  turnLeft() {
    if (this.bannerIndex - 1 < 0) {
      return (this.bannerIndex = this.bannerList.length - 1);
    }
    this.bannerIndex = this.bannerIndex - 1;
  }
  turnRight() {
    if (this.bannerIndex + 1 == this.bannerList.length) {
      return (this.bannerIndex = 0);
    }
    this.bannerIndex = this.bannerIndex + 1;
  }
  // banner

  linkUrl(url: any) {
    // window.open(url, '_blank');
    window.open(url, '_self');
  }
  // 成果展示轮播
  move() {
    this.timer2 = setInterval(this.starmove, 30);
  }
  //开始移动
  starmove() {
    this.calleft -= 1.2; //*this.speed
    if (this.calleft <= -250) {
      this.calleft = 0;
    }
  }
  //鼠标悬停时停止移动
  stopmove() {
    clearInterval(this.timer2);
  }
}
